import { gql } from '@apollo/client';

// Query to get a single appointment
export const GET_APPOINTMENT = gql`
  query GetAppointment($id: ID!) {
    getAppointment(id: $id) {
      id
      clientId
      client {
        id
        firstName
        lastName
        email
      }
      caseId
      title
      description
      startTime
      endTime
      locationName
      location
      attendeeIds
      guestEmails
      guests {
        name
        email
      }
      attendees {
        id
        firstName
        lastName
        email
      }
      googleCalendarEventId
      createdBy
      createdByName
      createdAt
      updatedAt
    }
  }
`;

// Query to list appointments by case
export const LIST_APPOINTMENTS_BY_CASE = gql`
  query ListAppointmentsByCase($caseId: ID!) {
    listAppointmentsByCase(caseId: $caseId) {
      id
      clientId
      caseId
      title
      description
      startTime
      endTime
      locationName
      location
      attendeeIds
      guestEmails
      guests {
        name
        email
      }
      attendees {
        id
        firstName
        lastName
        email
      }
      googleCalendarEventId
      createdBy
      createdByName
      createdAt
      updatedAt
    }
  }
`;

// Query to list appointments for current user
export const LIST_MY_APPOINTMENTS = gql`
  query ListMyAppointments($startDate: AWSDate, $endDate: AWSDate) {
    listMyAppointments(startDate: $startDate, endDate: $endDate) {
      id
      clientId
      client {
        id
        firstName
        lastName
      }
      caseId
      title
      description
      startTime
      endTime
      locationName
      location
      attendeeIds
      guestEmails
      guests {
        name
        email
      }
      attendees {
        id
        firstName
        lastName
        email
      }
      googleCalendarEventId
      createdBy
      createdByName
      createdAt
      updatedAt
    }
  }
`;

// Mutation to create an appointment (staff only)
export const CREATE_APPOINTMENT = gql`
  mutation CreateAppointment($input: CreateAppointmentInput!) {
    createAppointment(input: $input) {
      id
      clientId
      caseId
      title
      description
      startTime
      endTime
      locationName
      location
      attendeeIds
      guestEmails
      guests {
        name
        email
      }
      createdBy
      createdByName
      createdAt
      updatedAt
    }
  }
`;

// Mutation to update an appointment (staff only)
export const UPDATE_APPOINTMENT = gql`
  mutation UpdateAppointment($id: ID!, $input: UpdateAppointmentInput!) {
    updateAppointment(id: $id, input: $input) {
      id
      clientId
      caseId
      title
      description
      startTime
      endTime
      locationName
      location
      attendeeIds
      guestEmails
      guests {
        name
        email
      }
      updatedAt
    }
  }
`;

// Mutation to delete an appointment (staff only)
export const DELETE_APPOINTMENT = gql`
  mutation DeleteAppointment($id: ID!) {
    deleteAppointment(id: $id)
  }
`;

// Query to get current user (for Google Calendar connection status)
export const GET_CURRENT_USER_CALENDAR = gql`
  query GetCurrentUserCalendar {
    getCurrentUser {
      id
      email
      firstName
      lastName
      role
      googleCalendarConnected
      googleCalendarId
      googleCalendarLastSync
    }
  }
`;

// Mutation to connect Google Calendar (staff only)
export const CONNECT_GOOGLE_CALENDAR = gql`
  mutation ConnectGoogleCalendar {
    connectGoogleCalendar {
      authUrl
      message
    }
  }
`;

// Mutation to disconnect Google Calendar (staff only)
export const DISCONNECT_GOOGLE_CALENDAR = gql`
  mutation DisconnectGoogleCalendar {
    disconnectGoogleCalendar
  }
`;
